// extracted by mini-css-extract-plugin
export default {"tabs-step-wrapper":"TabsStep_tabs-step-wrapper__sQ0OM","tabs-step":"TabsStep_tabs-step__kgMD4"};